<template>
  <div>
    <div
      class="relative"
      style="display: inline-block !important; height: 0px !important"
    >
      <div
        class="caption-selector hide"
        @mouseenter="showCaptions"
        @mouseleave="offCaptionsHover"
        ref="captionHolder"
        :style="[captionScrollMargins, captionScrollHeight]"
      >
        <div class="caption-holder">
          <div class="caption-button" @click="clickCaption(`off`)">
            <div
              v-html="
                currentCaptions.value == `off`
                  ? CAPTION_RADIO_ON
                  : CAPTION_RADIO_OFF
              "
            ></div>
            <span v-html="`None`"></span>
          </div>
          <div
            class="caption-button"
            v-for="(caption, i) in subtitleArray.value"
            :key="i"
            @click="clickCaption(caption.language ? caption.language : `en`)"
          >
            <div
              v-html="
                currentCaptions.value == caption.language
                  ? CAPTION_RADIO_ON
                  : CAPTION_RADIO_OFF
              "
            ></div>
            <span
              v-html="
                caption.language
                  ? getLanguageString(caption.language)
                  : 'English'
              "
            ></span>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="canUseCaptions.value"
      class="pw-player-button"
      @mouseenter="showCaptions"
      @mouseleave="offCaptionsHover"
      ref="captionBtn"
      v-html="captionBtnString.value"
    ></div>
    <div
      v-if="canFullScreen"
      class="pw-player-button"
      @click="togglefullscreen()"
    >
      <svg
        class="bottom-icon"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.5 7.40909C5.5 6.63087 6.13087 6 6.90909 6H11.4545C12.2328 6 12.8636 6.63087 12.8636 7.40909C12.8636 8.18731 12.2328 8.81818 11.4545 8.81818H8.31818V11.9545C8.31818 12.7328 7.68731 13.3636 6.90909 13.3636C6.13087 13.3636 5.5 12.7328 5.5 11.9545V7.40909ZM19.1364 7.40909C19.1364 6.63087 19.7672 6 20.5455 6H25.0909C25.8691 6 26.5 6.63087 26.5 7.40909V11.9545C26.5 12.7328 25.8691 13.3636 25.0909 13.3636C24.3127 13.3636 23.6818 12.7328 23.6818 11.9545V8.81818H20.5455C19.7672 8.81818 19.1364 8.18731 19.1364 7.40909ZM5.5 20.0455C5.5 19.2672 6.13087 18.6364 6.90909 18.6364C7.68731 18.6364 8.31818 19.2672 8.31818 20.0455V23.1818H11.4545C12.2328 23.1818 12.8636 23.8127 12.8636 24.5909C12.8636 25.3691 12.2328 26 11.4545 26H6.90909C6.13087 26 5.5 25.3691 5.5 24.5909V20.0455ZM23.6818 20.0455C23.6818 19.2672 24.3127 18.6364 25.0909 18.6364C25.8691 18.6364 26.5 19.2672 26.5 20.0455V24.5909C26.5 25.3691 25.8691 26 25.0909 26H20.5455C19.7672 26 19.1364 25.3691 19.1364 24.5909C19.1364 23.8127 19.7672 23.1818 20.5455 23.1818H23.6818V20.0455Z"
          fill="white"
        />
      </svg>
    </div>
  </div>
</template>
<script lang="ts">
import "@/assets/video/caption-selector.css"
import { isFullScreenAvailable } from "@/services/fullScreenService"
import { computed, ComputedRef, defineComponent, PropType, Ref, ref } from "vue"
import setUpFullScreen from "@/composables/shared/fullscreen-hander"
import { isMobile } from "@/services/deviceDetection"
import replaceclass from "@/services/replaceClass"
import { SubtitleUrls } from "@/models/captions/SubtitleUrls"
import { getLanguageString } from "@/utils/getLanguageString"
export default defineComponent({
  props: {
    IS_IOS: { type: Boolean, required: true },
    playerContainer: {
      type: Object as PropType<Ref<HTMLElement | undefined>>,
      required: true
    },
    captionBtnString: { type: Object as PropType<Ref<String>>, required: true },
    canUseCaptions: {
      type: Object as PropType<Ref<Boolean>>,
      required: true
    },
    subtitleArray: {
      type: Object as PropType<Ref<SubtitleUrls[]>>,
      required: true
    },
    clickCaption: { type: Function, required: false },
    currentCaptions: { type: Object as PropType<Ref<String>>, required: true },
    height: { type: Object as PropType<ComputedRef<number>>, required: true }
  },
  setup(props) {
    let CAPTION_RADIO_OFF = `<svg class="caption-radio" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1 6C1 8.76142 3.23858 11 6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6ZM6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0Z" fill="#B7B7B7"/>
</svg>`
    let CAPTION_RADIO_ON = `<svg class="caption-radio" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect class="caption-radio" rx="6" fill="white"/>
</svg>`
    let captionHolder = ref<HTMLElement>()
    let captionScrollTimer = ref(0)
    let canFullScreen = ref(isFullScreenAvailable() && !props.IS_IOS)
    let { togglefullscreen } = setUpFullScreen(props.playerContainer)
    let captionScrollMargins = ref({
      "margin-left": `-${
        captionHolder.value ? captionHolder.value.clientWidth - 27 : 0
      }px !important`,
      "margin-top": `-${
        captionHolder.value ? captionHolder.value.clientHeight + 17 : 0
      }px !important`
    })
    let captionScrollHeight = computed(() => {
      return {
        height: `${
          (props.subtitleArray.value.length + 1) * 24 + 18 >
          props.height.value * 0.9
            ? props.height.value * 0.9
            : (props.subtitleArray.value.length + 1) * 24
        }px !important`
      }
    })

    return {
      captionScrollHeight,
      getLanguageString,
      CAPTION_RADIO_OFF,
      CAPTION_RADIO_ON,
      canFullScreen,
      togglefullscreen,
      captionScrollTimer,
      captionHolder,
      captionScrollMargins
    }
  },
  mounted() {
    this.setMargins()
  },
  methods: {
    onCaptionHover() {
      clearTimeout(this.captionScrollTimer)
    },
    offCaptionsHover() {
      this.captionScrollTimer = setTimeout(this.hideCaptions, 200)
    },
    showCaptions() {
      if (isMobile(navigator.platform, navigator.maxTouchPoints)) return
      clearTimeout(this.captionScrollTimer)
      replaceclass(this.captionHolder as HTMLElement, `hide`, `show`)
      this.setMargins()
    },
    hideCaptions() {
      clearTimeout(this.captionScrollTimer)
      replaceclass(this.captionHolder as HTMLElement, `show`, `hide`)
    },
    setMargins() {
      this.captionScrollMargins = {
        "margin-left": `-${
          this.captionHolder ? this.captionHolder.clientWidth - 27 : 0
        }px !important`,
        "margin-top": `-${
          this.captionHolder ? this.captionHolder.clientHeight + 17 : 0
        }px !important`
      }
    }
  }
})
</script>
